define([
	"dojo/_base/declare",
	"csi/action/SelectOneController",
	"csi/page"
], function(declare,SelectOneController,page) {

	return declare(SelectOneController, {
		toWriter: function() {
			var	call = this.inherited(arguments);
			this.m_writer.validateNode(this.m_urlNode);
			return call;
		},

		postProcessSuccess: function() {
			page.refreshRootView();
			this.widget.redrawNode();
		}
	});
});